import { render, staticRenderFns } from "./Diagnostic.vue?vue&type=template&id=55897376&"
import script from "./Diagnostic.vue?vue&type=script&lang=js&"
export * from "./Diagnostic.vue?vue&type=script&lang=js&"
import style0 from "./Diagnostic.vue?vue&type=style&index=0&id=55897376&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports